import React, { Component } from 'react';
import { HashLink as Link } from 'react-router-hash-link'; 

export class SanYingControllerStatusMonitor extends Component {
  static displayName = SanYingControllerStatusMonitor.name;

  constructor(props) {
    super(props);
    this.state = { currentCount: 0 };
    this.incrementCounter = this.incrementCounter.bind(this);
  }

  incrementCounter() {
    this.setState({
      currentCount: this.state.currentCount + 1
    });
  }

  render() {
    return (
      <div>
        <div class="mainbody" align="center">
          <img src="images/SanYingControllerStatusMonitor.png" border="0" style={{ verticalAlign: 'middle' }} />
        </div>

        <p />
        <div class="mainheader" align="center">
          <a href="download/Konkyu.Bvets.SanYingControllerMonitor.zip" target="_blank">[Download] Konkyu.Bvets.SanYingControllerMonitor.zip (94KB)</a> <br />
                Version: 1.0 (Build 6571.1104) <br />
                Release Date: 28 Dec 2017 (<Link to="#versionHistory">Release Note</Link>)
		    </div>

        <p />

        <div class="mainheader">
          <hr />
          <h3>Content</h3>
          <ul>
            <li><Link to="#license">License</Link></li>
            <li><Link to="#introduction">1. Introduction</Link></li>
            <li><Link to="#prerequisite">2. Prerequisite</Link></li>
            <li><Link to="#installation">3. Installation &amp; Usage</Link></li>
            <li><Link to="#systemSupport">4. Bugs Reporting &amp; System Support</Link></li>
            <li><Link to="#versionHistory">5. Release Note / Version History</Link></li>
          </ul>
          <hr />
          <h3 id="license">License</h3>
          <p>Konkyu.Bvets.SanYingControllerMonitor<br />Copyright © 2002-2021 </p>
          <p>Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:</p>
          <p>The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.</p>
          <p>THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.</p>
          <hr />
          <h3 id="introduction">1. Introduction</h3>
          <ul>
            <li>Konkyu.Bvets.SanYingControllerMonitor is a controller testing / status monitoring program designed for OHC-PC01 BVE Trainsim 5 Controller manufactured by San Ying Heavy Industry (三鶯重工).</li>
          </ul>
          <hr />
          <h3 id="prerequisite">2. Prerequisite</h3>
          <ul>
            <li>You must have the following applications installed before using the program:
                        <ul>
                <li><a href="http://www.microsoft.com/en-us/download/details.aspx?id=22" target="_blank">Microsoft .NET Framework 3.5</a></li>
                <li><a href="http://www.microsoft.com/en-us/download/details.aspx?id=35" target="_blank">DirectX End-User Runtime</a></li>
              </ul>
            </li>
          </ul>
          <hr />
          <h3 id="installation">3. Installation &amp; Usage</h3>
          <ol>
            <li>Unzip the package.</li>
            <li>Ensure you have the controller plugged in before launching the program.</li>
            <li>Execute "Konkyu.Bvets.SanYingControllerMonitor.exe" file.</li>
            <li>If prompted by Windows SmartScreen dialog, please click "Run Anyway" to run the program.</li>
          </ol>
          <hr />
          <h3 id="systemSupport">4. Bugs Reporting &amp; System Support</h3>
          <ul>
            <li>Bugs Reporting &amp; System Support email: support@konkyu.net</li>
          </ul>
          <hr />
          <h3 id="versionHistory">5. Release Note / Version History</h3>
          <ul>
            <li>28 Dec 2017 - Version 1.0
                        <ul>
                <li>Initial release</li>
              </ul>
            </li>
          </ul>
        </div>

      </div>
    );
  }
}
